import { mainFetch } from "../mainFetch";

const SERVICE_URL = '/shipment'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class ShipmentsApi {

    static async createShipment({ data = { market: undefined, shop: undefined, time_scheduled: undefined, isExpress: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/create', method: 'POST', data, notify: { msg: 'Отгрузка создана' }, ...params })
    }

    static async getShipments({ data = { market: undefined, isExpress: undefined, shipmentDate: undefined, status: undefined, limit: undefined, page: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/getshipments', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async changeShipment({ data = { shipmentId: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changeshipment', method: 'PATCH', data, ...params })
    }

    static async deleteShipment({ data = { shipmentId: undefined }, ...params }) {
        return await fetchService({ url: '/deleteshipment', method: 'DELETE', data, notify: { msg: 'Отгрузка удалена' }, ...params })
    }




    static async changeMethodRate({ data = { shipmentId: undefined, method: undefined, pay: undefined }, ...params }) {
        return await fetchService({ url: '/changemethodrate', method: 'PACTH', data, ...params })
    }

    static async getPackageStatistic({ data = { shipmentId: undefined }, ...params }) {
        return await fetchService({ url: '/getpackagestat', method: 'GET', data, notify: { success: false }, ...params })
    }

    static async getUsersStatistic({ data = { date: undefined, users: undefined }, ...params }) {
        return await fetchService({ url: '/getusersstatistic', method: 'POST', data, notify: { success: false }, ...params })
    }


    static async excelStatistic({ data = { shipments: undefined }, ...params }) {
        return await fetchService({ url: '/excelstatistic', method: 'POST', data, options: { download: true }, notify: { success: false }, ...params })
    }

}